import { render, staticRenderFns } from "./SuppliersRequestsPage.vue?vue&type=template&id=010c7372&"
import script from "./SuppliersRequestsPage.vue?vue&type=script&lang=js&"
export * from "./SuppliersRequestsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports